import { ranking } from "@/mocks/homeData";

const trendIcon: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", className: "text-primary-600", label: "上升" },
  same: { icon: "ri-subtract-line", className: "text-foreground-400", label: "持平" },
  down: { icon: "ri-arrow-down-line", className: "text-secondary-600", label: "下降" },
};

export default function RankingBoard() {
  const maxHeat = 100;

  return (
    <section id="ranking" className="border-t border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日热度榜</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              综合话题阅读量、评论增速与分享次数，每 30 分钟刷新一次。榜单只反映网友关注度，不代表任何立场。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100">
                <i className="ri-line-chart-line text-lg text-primary-600" />
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-900">榜单更新中</div>
                <div className="text-xs text-foreground-500">下次刷新：12 分钟前 已更新</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {ranking.map((item, index) => {
                const trend = trendIcon[item.trend] ?? trendIcon.same;
                const isTop3 = index < 3;
                return (
                  <a
                    key={item.title}
                    href="#stories"
                    className="group flex items-center gap-4 border-b border-background-200 px-4 py-4 transition-colors last:border-b-0 hover:bg-background-100/70 md:px-5"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        isTop3
                          ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>

                    <div className="min-w-0 flex-1">
                      <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[15px]">
                        {item.title}
                      </h3>
                      <div className="mt-2 flex items-center gap-3">
                        <span className="rounded-sm bg-secondary-100 px-2 py-0.5 text-[10px] font-medium text-secondary-800">
                          {item.tag}
                        </span>
                        <div className="h-1.5 w-full max-w-[220px] overflow-hidden rounded-full bg-background-200">
                          <div
                            className="h-full rounded-full bg-accent-500"
                            style={{ width: `${(Number(item.heat) / maxHeat) * 100}%` }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="flex shrink-0 items-center gap-2">
                      <span className="font-heading text-base font-bold text-foreground-900">{item.heat}</span>
                      <span className={`flex items-center ${trend.className}`} title={trend.label}>
                        <i className={trend.icon} />
                      </span>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}